/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DiemsRulesPLFixedRatesRes,
    DiemsRulesPLFixedRatesResFromJSON,
    DiemsRulesPLFixedRatesResFromJSONTyped,
    DiemsRulesPLFixedRatesResToJSON,
} from './';

/**
 * 
 * @export
 * @interface DiemsRules
 */
export interface DiemsRules {
    /**
     * 
     * @type {string}
     * @memberof DiemsRules
     */
    id?: string;
    /**
     * 
     * @type {DiemsRulesPLFixedRatesRes}
     * @memberof DiemsRules
     */
    plFixedRates?: DiemsRulesPLFixedRatesRes | null;
    /**
     * 
     * @type {number}
     * @memberof DiemsRules
     */
    readonly deleted?: number;
    /**
     * 
     * @type {Date}
     * @memberof DiemsRules
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof DiemsRules
     */
    end?: Date | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DiemsRules
     */
    replacedMeals?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof DiemsRules
     */
    pocketMoney?: number;
    /**
     * 
     * @type {Date}
     * @memberof DiemsRules
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof DiemsRules
     */
    concatForeignDiems?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DiemsRules
     */
    client: number;
    /**
     * 
     * @type {number}
     * @memberof DiemsRules
     */
    user?: number | null;
}

export function DiemsRulesFromJSON(json: any): DiemsRules {
    return DiemsRulesFromJSONTyped(json, false);
}

export function DiemsRulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiemsRules {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'plFixedRates': !exists(json, 'pl_fixed_rates') ? undefined : DiemsRulesPLFixedRatesResFromJSON(json['pl_fixed_rates']),
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'start': (new Date(json['start'])),
        'end': !exists(json, 'end') ? undefined : (json['end'] === null ? null : new Date(json['end'])),
        'replacedMeals': !exists(json, 'replaced_meals') ? undefined : json['replaced_meals'],
        'pocketMoney': !exists(json, 'pocket_money') ? undefined : json['pocket_money'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'concatForeignDiems': !exists(json, 'concat_foreign_diems') ? undefined : json['concat_foreign_diems'],
        'client': json['client'],
        'user': !exists(json, 'user') ? undefined : json['user'],
    };
}

export function DiemsRulesToJSON(value?: DiemsRules | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'pl_fixed_rates': DiemsRulesPLFixedRatesResToJSON(value.plFixedRates),
        'start': (value.start.toISOString()),
        'end': value.end === undefined ? undefined : (value.end === null ? null : value.end.toISOString()),
        'replaced_meals': value.replacedMeals,
        'pocket_money': value.pocketMoney,
        'concat_foreign_diems': value.concatForeignDiems,
        'client': value.client,
        'user': value.user,
    };
}


